import { Component, Input, OnInit } from '@angular/core';

import { countryCodes } from "./countryCodesData";
import { ModalController } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'app-countries',
  templateUrl: './countries.page.html',
  styleUrls: ['./countries.page.scss'],
})
export class CountriesPage {
  @Input({ required: false  }) showCountryName: boolean;

  constructor(private modalCtrl: ModalController) { }

  countries = countryCodes;
  loadedListOfCountries = countryCodes;

  getItems(ev) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the ev target
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '') {
      this.countries = this.countries.filter((country) => {
        return (country.name?.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  initializeItems() {
    this.countries = this.loadedListOfCountries;
  }

  close(country = null, countryName = null) {
    if (this.showCountryName) {
      this.modalCtrl.dismiss({ country, countryName });
    } else {
      this.modalCtrl.dismiss(country);
    }
  }

}
